/**
 * Cross-app header items — shown alongside (or instead of) per-app items.
 *
 * `about` is always-on (visible on `/` and inside every app, regardless of
 * api-key state). The per-suite app menus (e.g. "SafeSystem", "MIRE") and the
 * "Tools" menu are built in the root layout from `getAppsWithAvailability()`.
 *
 * `platformHelp` is the platform items in the Help menu (shown only at the
 * platform root, `/`); when an app is active the root layout appends per-app
 * help entries, the active app's version, and its release-notes link (from
 * `AppConfig.releaseNotesLink`).
 */

import type { HeaderItem } from '#lib/components/Header.svelte';
import type { MenuItem } from '#lib/components/MenuButton.svelte';
import { platformAppVersion } from '#lib/config.js';
import { ableyUrl } from '#lib/stores/jurisdictionStore.svelte.js';

export const about = (): HeaderItem => ({ label: 'About Abley', href: ableyUrl() });

export const platformHelp: MenuItem[] = [{ info: { label: `Platform: v${platformAppVersion}` } }];
